import { CCCLinkList, LinkListItem } from "../components/link-list/index";
import { CCCPanel } from "../components/panel/panel";
// Import utils

import { getDomElement } from "../core/utilities";
import { VanillaPagesType } from "../core/types/VanillaPages";
import OContentModel from "../models/OContentModel";
import { DataFolderAnnouncementsResponse } from "../core/interfaces/OcontentResponses";
import { AnnouncementType } from "../core/types/Announcements";
import CategoryModel from "../models/CategoryModel";
import DiscussionModel from "../models/DiscussionModel";

export interface AnnouncementsControllerOptions {
  anchor: string;
  catName: string;
}
export default class AnnouncementsController {
  private $anchor: HTMLElement = null;
  private announcementsDef: Array<DataFolderAnnouncementsResponse> = [];

  init(type: VanillaPagesType, opts: AnnouncementsControllerOptions): void {
    console.debug("Annauncements Panel - INIT");
    switch (type) {
      case VanillaPagesType.discussions:
        this._initForDiscussions(opts);
        break;
      default:
        console.error(
          `Announcements Panel - ${type} page type is not supported`
        );
        break;
    }
  }

  private async _initForDiscussions(
    opts: AnnouncementsControllerOptions
  ): Promise<boolean> {
    try {
      this.$anchor = <HTMLElement>getDomElement(opts.anchor);
      if (this.$anchor) {
        this.announcementsDef = await OContentModel.getAnnouncementsConfig(
          opts.catName
        );
        this._loadAnnouncementPanels();
      } else {
        throw `Announcements Panel - ${this.$anchor} element not found in DOM`;
      }

      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  private _loadAnnouncementPanels(): void {
    if (this.announcementsDef.length === 0) {
      throw "Announcements Panel - No announcements config for category";
    }

    const errorPromises: Array<Promise<boolean>> = [];

    this.announcementsDef.forEach((config) => {
      if (
        [
          AnnouncementType.category,
          AnnouncementType.singleTag,
          AnnouncementType.multipleTags,
        ].indexOf(config.type) > -1
      ) {
        errorPromises.push(this._buildAnnouncementPanel(config));
      } else {
        console.error(
          "Announcements Panel - Not a valid announcement config type"
        );
      }
    });

    Promise.all(errorPromises).then((results) => {
      console.debug(
        "Announcements Panel - Promise results: ",
        this.announcementsDef,
        results
      );
    });
  }

  private async _buildAnnouncementPanel(
    config: DataFolderAnnouncementsResponse
  ): Promise<boolean> {
    const $cccPanel: CCCPanel = <CCCPanel>document.createElement("ccc-panel");
    try {
      $cccPanel.setAttribute("title", config.title);
      const $cccLinkList: CCCLinkList = <CCCLinkList>(
        document.createElement("ccc-link-list")
      );
      $cccLinkList.setAttribute("slot", "component");
      $cccPanel.append($cccLinkList);
      this.$anchor.append($cccPanel);
      const catUrl =
        process.env.VANILLA_COMMUNITY_URL + "categories/" + config.urlCode;
      const cat = await CategoryModel.loadCategoryJson(catUrl);
      let announcements: Array<LinkListItem> = [];
      const currDate = new Date();
      const afterDate = new Date(
        `${currDate.getFullYear() - 1}-${
          currDate.getMonth() + 1
        }-${currDate.getDate()}`
      );
      announcements = await DiscussionModel.getLinkList(
        cat.CategoryID,
        5,
        config.type === AnnouncementType.singleTag
          ? [config.tag]
          : config.type === AnnouncementType.multipleTags
          ? config.tags
          : [],
        true,
        afterDate
      );

      if (announcements.length > 0) {
        console.debug("Announcements Panel - Anauncements:", announcements);
        $cccLinkList.setState({
          title: "",
          links: announcements,
          moreLink: catUrl,
        });
        $cccLinkList.loading = false;
        return true;
      } else {
        $cccPanel.hide();
        return false;
      }

      return true;
    } catch (err) {
      console.error(err);
      $cccPanel.hide();
      return false;
    }
    return false;
  }
}
